export const buildRequestFromFetchInput = (
  input: Parameters<Window['fetch']>[0],
  init?: Parameters<Window['fetch']>[1],
): Request => {
  if (input instanceof Request) return input;

  const safeInput =
    typeof input === 'string'
      ? new URL(input.toString(), window.location.href)
      : input;

  return new Request(safeInput, init);
};

import type { XMLHttpRequestWithExtras } from './types';

const dbgID = () => Math.random().toString(16).slice(2, 6);

export const buildRequestFromXHR = (xhr: XMLHttpRequest): Request => {
  const url = new URL(xhr.responseURL || '', window.location.href);
  const method = (xhr as any)._method || 'GET'; // _method is a custom property we set when intercepting XHR
  const headers = new Headers();

  // Populate headers from XHR
  const rawHeaders = xhr.getAllResponseHeaders();
  rawHeaders.split('\r\n').forEach((line) => {
    const [key, value] = line.split(': ');
    if (key && value) {
      headers.append(key, value);
    }
  });

  return new Request(url.toString(), {
    method,
    headers,
    // Note: Body extraction from XHR is non-trivial and may require additional handling
  });
};

export const cloneXHR = (
  originalXhr: XMLHttpRequestWithExtras,
): XMLHttpRequestWithExtras => {
  const clonedXhr = new XMLHttpRequest() as XMLHttpRequestWithExtras;
  clonedXhr.__ID = `${originalXhr.__ID}_cloned_${dbgID()}`;
  clonedXhr.__ogXHR = originalXhr.__ogXHR ? originalXhr.__ogXHR : originalXhr;
  originalXhr.__currentXHR = clonedXhr;

  // Copy method and URL
  const method = (originalXhr as any)._method || 'GET';
  const url = originalXhr.responseURL || '';

  // Open the request with same method and URL
  clonedXhr.open(method, url, true);

  // Copy request headers if available
  if ((originalXhr as any)._requestHeaders) {
    const requestHeaders = (originalXhr as any)._requestHeaders;
    for (const [key, value] of Object.entries(requestHeaders)) {
      clonedXhr.setRequestHeader(key, value as string);
    }
  }

  // Copy other properties
  clonedXhr.timeout = originalXhr.timeout;
  clonedXhr.withCredentials = originalXhr.withCredentials;
  clonedXhr.responseType = originalXhr.responseType;

  return clonedXhr as XMLHttpRequestWithExtras;
};
export const newOGXHR = (
  OGXMLHttpRequest: typeof XMLHttpRequest,
  ...args: ConstructorParameters<typeof XMLHttpRequest>
): XMLHttpRequestWithExtras => {
  const xhr = new OGXMLHttpRequest(...args) as XMLHttpRequestWithExtras;
  xhr.__ID = dbgID();
  xhr.__ogXHR = xhr;
  xhr.__currentXHR = xhr;

  return xhr;
};
